/** Users who joined before this date are Founding Athletes */
const FOUNDER_CUTOFF = '2026-06-01T00:00:00Z';

export function isFoundingAthlete(createdAt?: string): boolean {
  if (!createdAt) return false;
  return new Date(createdAt) <= new Date(FOUNDER_CUTOFF);
}
